<!-- Optimized MinMax Template -->
<div class="row">
    <div class="col-lg-12 col-xl-12 stretch-card" id="min_max">
        <header class="d-none">
            <div class="row">

                <div class="col-sm">
                    <img width="180" src="../../../../assets/images/TEB_Logo 7.jpg">
                </div>

                <div class="col-sm d-flex justify-content-end">
                    <h4>{{ user?.company }}</h4>
                </div>
            </div>

            <div class="row" style="margin-top: -10px;">

                <div class="col-sm d-flex justify-content-end">
                    <h6>{{ curr_date }}</h6>
                </div>
            </div>
        </header>
        <div class="row flex-grow">

            <div class="d-grid col grid-margin stretch-card">
                <div class="card">
                    <div class="d-flex justify-content-between card-header align-items-center mb-4 mb-md-3">
                        <h6 class="card-title mb-0 ">Minimum and Maximum Values / {{location}}</h6>

                        <div class="d-flex align-items-center justify-content-end">
                            <button class="btn mr-1 pr-1" type="button" data-toggle="collapse"
                                data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
                                <i class="feather-sliders"
                                    style="font-size:x-large; color: #ff0000;; font-weight: 500;"></i>
                            </button>
                            <div class="dropdown ml-2">
                                <button class="btn p-0" type="button" id="dropdownMenuButton3" data-toggle="dropdown"
                                    aria-haspopup="true" aria-expanded="false">
                                    <i class="icon-sm pb-3px card-header-icon feather feather-more-vertical"></i>
                                </button>
                                <div id="hideprint" class="dropdown-menu" aria-labelledby="dropdownMenuButton3">
                                    <button [useExistingCss]="true" printSectionId="min_max" ngxPrint type="button"
                                        class="dropdown-item d-flex align-items-center" name="Print">
                                        <i class="feather feather-printer icon-sm mr-2"></i>
                                        <span class="">Print</span>
                                    </button>
                                    <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);"
                                        (click)="exportAsCSV()">
                                        <i class="feather feather-download icon-sm mr-2"></i>
                                        <span class="">Export as CSV</span>
                                    </a>
                                    <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);"
                                        name="Pdf" (click)="data_param_el = 'min_max'; exportAsPDF($event)">
                                        <i class="feather feather-file-text icon-sm mr-2"></i>
                                        <span class="">Export as PDF</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="collapse px-2" id="collapseExample">
                        <div class="card-body" style="overflow: visible; padding-bottom: 20px;">
                            <div class="header-right-inner-left d-flex align-items-center flex-wrap">
                                <div class="form-group mb-0 mr-2">
                                    <h6 class="mb-0">Select Date:</h6>
                                </div>
                                <div class="form-group mb-0 mr-3">
                                    <input type="date" [(ngModel)]="date" autocomplete="off" class="form-control"
                                        (change)="onDateSelection($event)">
                                </div>
                                
                                <div class="form-group mb-0 mr-2">
                                    <h6 class="mb-0">Interval:</h6>
                                </div>
                                <div class="form-group mb-0 mr-3">
                                    <select class="form-control" [(ngModel)]="fixed_interval" (change)="onIntervalSelection($event)">
                                        <option *ngFor="let opt of intervalOptions" [value]="opt.value">{{ opt.name }}</option>
                                    </select>
                                </div>

                                <div class="form-group mb-0 mr-2">
                                    <h6 class="mb-0">Parameters:</h6>
                                </div>
                                <div class="form-group mb-0 mr-3" style="min-width: 300px;">
                                    <ng-multiselect-dropdown [placeholder]="'Select Parameters'"
                                        [settings]="dropdownSettings" [data]="parametersList"
                                        [(ngModel)]="selectedParameters">
                                    </ng-multiselect-dropdown>
                                </div>

                                <div class="form-group mb-0">
                                    <button class="btn btn-primary" style="background-color: #073C5C; border: none;" (click)="viewData()">View</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mr-0 card-body">
                        <div class="table-responsive">
                            <table class="table table-bordered">
                                <thead>
                                    <tr id="table-head"
                                        style="text-align: center; color: white; background-color: #073C5C;">
                                        <th style="color: white;" width="20%"><b>Parameters</b></th>
                                        <th style="color: white;" width="10%"><b>Unit</b></th>
                                        <th style="color: white;" width="10%"><b>Min. Value</b></th>
                                        <th style="color: white;" width="15%"><b>Min. Time</b></th>
                                        <th style="color: white;" width="10%"><b>Max. Value</b></th>
                                        <th style="color: white;" width="15%"><b>Max. Time</b></th>
                                    </tr>
                                </thead>

                                <tbody *ngIf="displayedParametersList.length > 0">
                                    <tr *ngFor="let param of displayedParametersList; let i = index"
                                        [style.background-color]="i % 2 !== 0 ? 'rgb(228, 228, 228)' : 'white'"
                                        style="color: black;">
                                        <td style="text-align: center;"><b>{{ param.params }}</b></td>
                                        <td style="text-align: center;"><b>{{ param.unit }}</b></td>
                                        <td style="color: rgb(30, 182, 0); text-align: center;"><b>{{
                                                param.min.toFixed(2) }}</b></td>
                                        <td style="color: rgb(30, 182, 0); text-align: center;"><b>{{ param.minDate
                                                }}</b></td>
                                        <td style="color: red; text-align: center;"><b>{{ param.max.toFixed(2) }}</b>
                                        </td>
                                        <td style="color: red; text-align: center;"><b>{{ param.maxDate }}</b></td>
                                    </tr>
                                </tbody>
                                <tbody *ngIf="displayedParametersList.length === 0">
                                    <tr>
                                        <td colspan="6" style="text-align: center; padding: 20px;">
                                            <b>No parameters selected. Please select parameters and click View to see the data.</b>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- row -->